import React from 'react'
import {
  StyleSheet,
  Text,
  View,
  ViewStyle,
  StyleProp,
  Image,
} from 'react-native'

import {
  COLORS,
  COMMON_STYLES,
  PARAGRAPH_STYLES,
  SUBHEADING_STYLES,
  TEXT_STYLES,
} from '@dehaat/dds'
import { DC_ICON } from 'app/assets/images'

interface Props {
  name: string
  address: string
  viewStyle?: StyleProp<ViewStyle>
}

const DcCard = ({ name, address, viewStyle }: Props) => {
  return (
    <View style={[styles.container, viewStyle]}>
      <View style={[COMMON_STYLES.p1, COMMON_STYLES.row]}>
        <View style={styles['flex0.2']}>
          <View style={styles.dcIcon}>
            <Image source={DC_ICON} style={styles.dcImage} />
          </View>
        </View>
        <View style={styles['flex0.8']}>
          <Text style={[SUBHEADING_STYLES.MEDIUM_S3, TEXT_STYLES.textBlack]}>
            {name}
          </Text>
          <Text
            style={[
              PARAGRAPH_STYLES.RegularT2,
              styles.neutral90,
              COMMON_STYLES['mt1/2'],
            ]}
          >
            {address}
          </Text>
        </View>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderRadius: 16,
    borderColor: '#AECC70',
    backgroundColor: '#E2F2C2',
    justifyContent: 'space-between',
    marginTop: 16,
  },
  'flex0.2': {
    flex: 0.2,
  },
  'flex0.8': {
    flex: 0.8,
  },
  dcIcon: {
    width: 48,
    height: 48,
    backgroundColor: COLORS.white,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 8,
  },
  neutral90: {
    color: COLORS.neutral90,
  },

  dcImage: {
    height: 32,
    width: 40,
  },
})

export default DcCard
